module.exports = __webpack_public_path__ + "media/images/pro_subscription/carousel4-fr-FR@3x-9626989af57faa21ea9c1cd8158ad134.png";